import React from 'react';
import {About, Footer, Header2, Skills, Testimonials, Work} from './container';
import { Navbar } from './components';
import Particles from './components/Particles';
import './App.scss';
// import Design from "./components/Particles";

const App = () => {
  return (
      <div className='app'>
        {/* <Design/> */}
        <Navbar/>
        <Header2/> 
        <About/>
        <Work/>
        <Skills/>
        <Testimonials/>
        <Footer/>
        <Particles id="tsparticles" />
        
      </div>
    
  );
}

export default App;
